// date.js
export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

export function str2Date (dateStr, separator) {
  if (!separator) {
    separator = "-"
  }
  let dateArr = dateStr.split(separator)
  let year = parseInt(dateArr[0])
  let month
  //处理月份为04这样的情况
  if (dateArr[1].indexOf("0") == 0) {
    month = parseInt(dateArr[1].substring(1))
  } else {
    month = parseInt(dateArr[1])
  }
  let day = parseInt(dateArr[2])
  let date = new Date(year, month - 1, day)
  return date
}

export function timeNow () {
  let vWeek, vWeek_s, year, month, day, hours, minutes, seconds
  vWeek = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
  let date = new Date()
  year = date.getFullYear()
  month = date.getMonth() + 1
  day = date.getDate()
  hours = date.getHours()
  hours = hours > 9 ? hours : "0" + hours
  minutes = date.getMinutes()
  minutes = minutes > 9 ? minutes : "0" + minutes
  seconds = date.getSeconds()
  seconds = seconds > 9 ? seconds : "0" + seconds
  vWeek_s = date.getDay()
  let time = year + "年" + month + "月" + day + "日" + "\t" + hours + ":" + minutes + ":" + seconds + "\t" + vWeek[vWeek_s]
  return time
}
export function fun_date (aa) {
  let date1 = new Date()
  let date2 = new Date(date1)
  date2.setDate(date1.getDate() + aa)
  let month = date2.getMonth() + 1
  month = month > 9 ? month : "0" + month
  let day = date2.getDate()
  day = day > 9 ? day : "0" + day
  let time2 = date2.getFullYear() + "-" + month + "-" + day
  return time2
}


// WEBPACK FOOTER //
// ./src/utils/date.js